import React from 'react';
import { PdfComponent, PdfComponentType } from '../../PdfComponent';
import PdfTemplateComponentName from './PdfTemplateComponentName';
import PdfTemplateComponentRepeat from './PdfTemplateComponentRepeat';
import PdfTemplateComponentSize from './PdfTemplateComponentSize';

export default function PdfTemplateComponentDefault({ component }: { component: PdfComponent }) {
  return (
    <>
      <p className='section-title'>General</p>
      <PdfTemplateComponentName component={component} />
      <PdfTemplateComponentSize component={component} />
      {component.type !== PdfComponentType.table && <PdfTemplateComponentRepeat component={component} />}
    </>
  );
}
